import { Action } from 'redux';

//import * as moment from 'moment';
import moment from 'moment';

import 'moment-timezone';
import { MomentTimeZoneEnum } from 'src/app/shared/enums/moment-timezone.enum';
import { ShoppingDateStateStructure } from '../interfaces/shopping-date.state-structure.interface';
import { environment } from 'src/environments/environment';
import * as DateFunctions from 'src/app/shared/services/date.functions';

/** @TODO - generate based on Environment File. */
const currentTimeZone = MomentTimeZoneEnum[environment.configs.siteTimeZone];

export const SHOPPING_DATE_STATE_NAME = 'ShoppingDates';

/** INITIAL STATE */
const INITIAL_STATE: ShoppingDateStateStructure = {
  sellThisYearProductsDate: 'Nov 30',
  showNextYearProductsDate: 'Oct 1',
  sellNextYearProductsDate: 'Oct 14'
};

/** ACTION TYPES */
const SET_NEXT_YEAR_SHOPPING_PRODUCT_DATES = 'SET_NEXT_YEAR_PRODUCT_DATE';

/** ACTION INTERFACE */
export class ShoppingDates implements Action {
  type: string;
  nextYearShoppingProductDates?: ShoppingDateStateStructure;
}

/** EFFECTIVE DATE ACTIONS */
export function setNextYearShoppingDates(nextYearShoppingProductDates: ShoppingDateStateStructure) {
  return { type: SET_NEXT_YEAR_SHOPPING_PRODUCT_DATES, nextYearShoppingProductDates };
}

/** REDUCER */
export function NextYearShoppingDates(state: ShoppingDateStateStructure = INITIAL_STATE, action: ShoppingDates) {

  const copiedState: ShoppingDateStateStructure = JSON.parse(JSON.stringify(Object.assign({}, state)));

  switch (action.type) {
    case SET_NEXT_YEAR_SHOPPING_PRODUCT_DATES:
      const currentYear = DateFunctions.getNow().year();

      copiedState.sellThisYearProductsDate =
        moment(action.nextYearShoppingProductDates.sellThisYearProductsDate).year(currentYear).tz(currentTimeZone).format('YYYY-MM-DD');
      copiedState.showNextYearProductsDate =
        moment(action.nextYearShoppingProductDates.showNextYearProductsDate).year(currentYear).tz(currentTimeZone).format('YYYY-MM-DD');
      copiedState.sellNextYearProductsDate =
        moment(action.nextYearShoppingProductDates.sellNextYearProductsDate).year(currentYear).tz(currentTimeZone).format('YYYY-MM-DD');
      return Object.assign({}, state, copiedState);
    default:
      return state;
  }

}
